"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShadesAndDetails = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _ProductDetails = require("../ProductDetails");
var _ShadesCarousel = require("./ShadesCarousel");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ShadesAndDetails = ({
  id,
  bonusPoints,
  currentShade,
  productCode,
  size,
  shades,
  className,
  productDetailsClassName,
  setCurrentShadeProductCode
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const isMultiShade = shades.length > 1;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_constants.SHADES_AND_DETAILS),
    className: className,
    children: [isMultiShade ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ShadesCarousel.ShadesCarousel, {
      currentShade: currentShade,
      setCurrentShadeProductCode: setCurrentShadeProductCode,
      shades: shades,
      id: id
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProductDetails.ProductDetails, {
      currentShade: currentShade,
      productCode: productCode,
      bonusPoints: bonusPoints,
      className: productDetailsClassName,
      isMultiShade: isMultiShade,
      size: size
    })]
  });
};
exports.ShadesAndDetails = ShadesAndDetails;
